import React from "react";

import Editor from './ABridTextEditor'
import EditorWrapper from '../../EditorWrapper'

import BridText from "../../common/BridText";
import Article from "../../common/EmptyArticle";


const ABridText = props => {
    let article = Article();
    const { settings } = props;

    article.title = settings.title_normal;
    article.label = settings.label;

    // props.onRegisterBox(props.blockId, props.id, 'title_normal')

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <BridText article={article} />
        </div>
    );
};

export default ABridText;
